import { InputAdornment, Paper, Stack, TextField, Typography } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { useState } from "react";
import useSections from "../Hooks/useSections";
import { Link, useParams } from "react-router-dom";
import { txt } from "../../../services/translation";

export default function Search(){

    const {course} = useParams()

    const [search, setSearch] = useState('')

    const sections = useSections()

    const results = sections.filter(s => 
        (s.title?.toLowerCase() + ' ' + s.chapter?.title?.toLowerCase() + ' ' + s.type?.title?.toLowerCase())
            .includes(search.toLowerCase())
    )

    return <Stack sx={{p: 1}}>

        <TextField
            label={txt('searchInputLabel')}
            type='search'
            size='small'
            value={search}
            onChange={e => setSearch(e.target.value)}
            InputProps={{
                startAdornment: <InputAdornment position='start'><SearchIcon /></InputAdornment>
            }}
            sx={{mb: 2}}
            variant='filled'
        />

        {results.map(s => 
        
            <Link to={`/study/${course}/${s.id}`} key={s.id}>
                <Paper variant='outlined' sx={{p: 1, mb: 1}}>
                    <Typography>
                        {s.title}
                        <br/>
                        <small>{s.type?.title}</small>
                    </Typography>
                    
                    <Typography variant='span'>{txt('chapterPoint')} {s.chapter?.title}</Typography>

                </Paper>
            </Link>
        )}

    </Stack>
}